import './Legal.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-content">
          <h1>Privacy Policy</h1>
          <p className="last-updated">
            Last Updated: {new Date().toLocaleDateString()}
          </p>

          <section>
            <h2>1. Information We Collect</h2>
            <p>
              We collect information that you directly provide to SradhaTech to facilitate communication, service delivery, and campaign participation. This includes:
            </p>
            <ul>
              <li><strong>Contact Information:</strong> Your full name, email address, phone number, and any other identifying details provided via our contact forms.</li>
              <li><strong>Messaging Data:</strong> Records of your SMS consent, opt-in/opt-out preferences, and the history of communications between you and our campaigns.</li>
              <li><strong>Professional Information:</strong> Details regarding your business, project requirements, or professional inquiries provided to us.</li>
              <li><strong>User Submissions:</strong> Any information you voluntarily provide in free-form text fields, surveys, or direct inquiries.</li>
            </ul>
          </section>

          <section>
            <h2>2. How We Use Your Information</h2>
            <p>SradhaTech uses the information collected to operate our business efficiently and provide a secure, personalized experience. Specifically, your data is used to:</p>
            <ul>
              <li><strong>Service Delivery & Communication:</strong> Respond to your inquiries, provide requested services, and communicate regarding potential business opportunities.</li>
              <li><strong>Campaign Management:</strong> Send relevant updates, newsletters, and informational SMS campaigns, strictly subject to your explicit opt-in consent.</li>
              <li><strong>Analytics & Optimization:</strong> Perform campaign tracking and analytics to measure engagement, improve our messaging strategies, and enhance the overall performance of our website and services.</li>
              <li><strong>Compliance:</strong> Fulfill legal obligations and comply with applicable regulatory requirements.</li>
            </ul>
          </section>

          <section>
            <h2>3. Information Storage and Protection</h2>
            <p>
              We implement reasonable security measures designed to protect your information, including names, email addresses, phone numbers, and messages, from unauthorized access, use, or disclosure. Data is stored securely and retained only as long as necessary to fulfill the purposes outlined in this Privacy Policy.
            </p>
          </section>

          <section>
            <h2>4. Information Sharing</h2>
            <p>
              SradhaTech respects your privacy and does not sell your personal information. We only share your information under the following circumstances:
            </p>
            <ul>
              <li><strong>Internal Operations:</strong> With our trusted employees and authorized personnel who require the data to perform their job duties in servicing you.</li>
              <li><strong>Service Providers:</strong> With third-party vendors and partners who assist in operating our website, conducting our business, or servicing you.</li>
              <li><strong>Telecommunication Entities:</strong> With mobile carriers, aggregators, and messaging campaign registries strictly for the purpose of SMS registration, routing, and compliance verification.</li>
              <li><strong>Legal Requirements:</strong> With law enforcement or legal authorities when reasonably necessary to comply with a legal process or lawful request.</li>
            </ul>
          </section>

          <section>
            <h2>5. SMS Privacy and Opt-Out Policy</h2>
            <p>
              <strong>Disclaimer:</strong> Mobile information will not be shared with third parties or affiliates for marketing/promotional purposes. All the above categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties.
            </p>
            <h3>Opt-Out Policy</h3>
            <p>
              If at any point you no longer wish to receive communications from us, you can easily opt out by replying with STOP or QUIT to any message.
            </p>
          </section>

          <section>
            <h2>6. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Opt-out of marketing communications</li>
            </ul>
          </section>

          <section>
            <h2>7. Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy, please contact us
              at:{' '}
              <button
                type="button"
                className="email-link"
                onClick={() =>
                (window.location.href =
                  'mailto:privacy@sradhatech.com')
                }
              >
                privacy@sradhatech.com
              </button>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
